import React, { useState } from 'react';

import { analyticsProps } from '@class-ui/insights';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { ActionButton } from './index.styles';
import { GenericIFrameDialog } from './Modals/GenericIframeDialog';
import TemplatesContainer from './TemplateContext';
import { getUrls } from '../../utils/url';

const StyledIFrame = styled('iframe')`
    width: 100%;
    height: 100%;
    border: none;
`;


const VideosSection = () => {
    const { t } = useTranslation('templates');
    const { vanityUrl } = getUrls();
    const { createEditResponse } = useContainer(TemplatesContainer);
    const [genericIFrame, setGenericIFrame] = useState<null | { label: string; url: string }>(null);
    const { class_uuid: classId, token  } = createEditResponse || {};
    return (
        <>
            <ActionButton disabled={!createEditResponse} variant="contained" color="primary"
                onClick={() => {
                    setGenericIFrame({
                        label: t('videos'),
                        url: `${vanityUrl}/common/videos?class_id=${classId}&token=${token}&isTemplateEditor=true`
                    });
                }}
            >{t('videos')}</ActionButton>
            {genericIFrame && (
            <GenericIFrameDialog
                url={genericIFrame.url}
                handleClose={() => setGenericIFrame(null)}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick') {
                        return; //prevent close
                    }
                    setGenericIFrame(null);
                }}
                {...analyticsProps('collaborate-dialog-launch-tool', {
                    contentName: 'template-videos'
                })}
            />
            )}
        </>
    );
};

export default VideosSection;
